import React from "react";
import { Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";

const RealEstateService = ({ image, title, location }) => {
  return (
    <Stack justifyItems={"center"} alignItems={"center"}>
      <Box
        sx={{
          width: "300px",
          height: "300px",
        }}
      >
        <img
          src={image}
          alt=""
          style={{
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      </Box>

      <Typography
        sx={{
          padding: "20px 10% 10px 10%",
          lineHeight: "1.5",
          textAlign: "center",
          fontSize: "26px",
          color: "#737373",
        }}
        variant="h6"
        component="div"
        fontWeight="bold"
      >
        {title}
      </Typography>
      <Typography
        sx={{
          padding: "10px 10%",
          lineHeight: "1.5",
          textAlign: "center",
          fontSize: "16px",
          height: "100px",
        }}
        variant="body1"
        color="text.secondary"
      >
        {location}
      </Typography>
    </Stack>
  );
};

export default RealEstateService;
